import React, { useContext, useMemo, useState } from "react";
import { useTextDomainContext, useUser } from "@/app/providers";
import { useCompanyBuildings } from "@/hooks";
import { SelectDropdown } from "@/components";
import { BuildingDropdownProps } from "./BuildingDropdown.types";

export const BuildingDropdown = (props: BuildingDropdownProps) => {
  //#region Data
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { user } = useUser();
  const {
    currentTeam: currentTeamDefault,
    currentSubsidiary: currentSubsidiaryDefault,
  } = user || {};
  //#endregion Data

  const [newDefaultValue, setNewDefaultValue] = useState(null);

  //#region useMemo
  const componentLabel = useMemo(() => {
    return props.componentLabel || gettext("Location");
  }, [gettext, props.componentLabel]);

  const defaultValue = useMemo(() => {
    return newDefaultValue || props.defaultValue || "";
  }, [newDefaultValue, props.defaultValue]);

  const currentTeam = useMemo(() => {
    return props.currentTeam || currentTeamDefault || "";
  }, [currentTeamDefault, props.currentTeam]);

  const currentSubsidiary = useMemo(() => {
    return props.currentSubsidiary || currentSubsidiaryDefault || "";
  }, [currentSubsidiaryDefault, props.currentSubsidiary]);

  const country = useMemo(() => {
    return props.country || "";
  }, [props.country]);

  const zone = useMemo(() => {
    return props.zone || "";
  }, [props.zone]);

  //#endregion useMemo

  //#region Options

  const variables = {
    customerName: currentTeam,
    subsidiaryName: currentSubsidiary,
    country,
    zone,
  };

  const { buildings: options } = useCompanyBuildings(variables);

  //#endregion Options

  //#region Handlers

  const handleChange = (event: any) => {
    // if (event.value !== buildingValue) {
    setNewDefaultValue(event);
    if (typeof props.onChange === "function") {
      props.onChange(event);
    }
    // }
  };

  //#endregion Handlers

  return (
    <SelectDropdown
      options={
        options as unknown as import("@/types/Dropdown.types").DropdownOption[]
      }
      componentLabel={componentLabel}
      defaultValue={defaultValue}
      showAll={props.showAll}
      required={props.required}
      onChange={handleChange}
      refetch={props.refetch || false}
      refetched={props.refetched}
      visualStyle="autoComplete"
      sx={{
        ...props.sx,
      }}
    />
  );
};
